module.exports = __webpack_public_path__ + "img/avatar_3.3688246d.jpg";